/* eslint-disable */
export default {
  _0: '0',
  _1: '1',
  _2: '2',
  _3: '3',
  _4: '4',
  _5: '5',
  _6: '6',
  _7: '7',
  _8: '8',
  _9: '9',
  _10: '10',
  _11: '11',
  _12: '12',
  _13: '13',
  _14: '14',
  _15: '15',
  _16: '16',
  _17: '17',
  _18: '18',
  _19: '19',
  _20: '20',
  _30: '30',
  _40: '40',
  _50: '50',
  _60: '60',
  _70: '70',
  _80: '80',
  _90: '90',
  _100: '100',
  _best_bonus_time_was: 'best_bonus_time_was',
  _bonus_round: 'bonus_round',
  _good_job: 'good-job',
  _nice: 'nice',
  _seconds: 'seconds',
  _title: 'title',
  _you_did_it_in: 'you_did_it_in',
  _you_did_it: 'you-did-it',
}